import { SubMenuListContainer } from '@model-framework/menu';
import { ZoneTitlePositionMainMenu } from './ZoneTitlePositionMainMenu';
import type { StickyZoneTitlePosition } from '../../../domain';
import { ZoneTitlePositionSubMenu } from './ZoneTitlePositionSubMenu';

type Props = {
  currentTitlePosition?: StickyZoneTitlePosition | null; // 複数選択時など現在の値が一意に決まらないケースがある
  menuSize: number;
  items: Readonly<StickyZoneTitlePosition[]>;
  isOpen: boolean;
  onMenuClicked(): void;
  onSelected(titlePosition: StickyZoneTitlePosition): void;
  text: string;
};

export const ZoneTitlePositionMenu: React.FC<Props> = ({
  currentTitlePosition,
  menuSize,
  items,
  isOpen,
  onMenuClicked,
  onSelected,
  text,
}: Props) => {
  const size = {
    width: menuSize * items.length,
    height: menuSize,
  };

  return (
    <g>
      <ZoneTitlePositionMainMenu isSelected={isOpen} menuSize={menuSize} onClick={onMenuClicked} text={text} />
      {isOpen && (
        <SubMenuListContainer menuSize={menuSize} rectSize={size}>
          {items.map((titlePosition, i) => {
            return (
              <g key={titlePosition} transform={`translate(${menuSize * i}, 0)`}>
                <ZoneTitlePositionSubMenu
                  titlePosition={titlePosition}
                  menuSize={menuSize}
                  isSelected={currentTitlePosition === titlePosition}
                  onClick={() => onSelected(titlePosition)}
                />
              </g>
            );
          })}
        </SubMenuListContainer>
      )}
    </g>
  );
};
